// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1-YXL","unreadBadge":"styles_unreadBadge__1o1QP","modalContent":"styles_modalContent__3mfL7","modal":"styles_modal__1Th7P"};